<template>
	<div class="pick-list-box">
		<div class="top-header">
			<!-- <el-button size="mini" type="primary" v-print="'#printTest'">{{$t('other.a342')}}</el-button> -->
		</div>
		<div id="printTest">
			<div>
			    <div class="pick-list-wrpper">
					<div class="print-area" v-if="signList.length">
						<div style="height: 295mm;" v-for="(item,index) in signList" :key="index">
							<div style="text-align: right;padding: 10px 0;">
								<span class="header-desc">{{showShopName(shopId)}}</span>
								<span class="header-desc">{{item.time}}</span>
								<span class="header-desc">{{item.page}}/{{signList.length}}</span>
							</div>
							<div style="display: flex;">
								<div  v-for="(list,indexone) in item.list" :key="indexone">
									<div>
										<el-table
											class="dksnfvnb"
										    :data="list"
											:cell-style="{borderColor:'#000'}"
											:header-cell-style="{borderColor:'#000'}"
										    border
										    >
										    <el-table-column
										      prop="no"
										      label="NO"
											  width="50"
										      >
										    </el-table-column>
										    <el-table-column
										      prop="orderId"
										      label="Order NO."
											  width="170"
										      >
										    </el-table-column>
										    <el-table-column
										      prop="trackingNo"
											  width="170"
										      label="Tracking No.">
										    </el-table-column>
										</el-table>
									</div>
								</div>
							</div>
							<div style="display: flex;width: 120%;margin-top: 20px;">
								<div style="display: flex;width: 780px;justify-content: space-between;">
									<div style="border: 1px #000 solid;font-size: 18px;width: 48%;" v-if="index+1 == signList.length">
										<div style="padding:10px;border-bottom:1px #000 solid; height: 30px;">
											<span>Total Number of Parcels：</span>
											<span>{{total}}</span>
										</div>
										<div style="padding:10px;border-bottom:1px #000 solid; height: 40px;">
											Signature of Shopee Express Standard Driver
										</div>
										<div style=" height: 200px;text-align: left;line-height: 300px;">
											Date：
									
										</div>
									</div>
									<div style="border: 1px #000 solid;font-size: 18px;width: 48%;" v-if="index+1 == signList.length">
										<div style="padding:10px;border-bottom:1px #000 solid; height: 30px;">
											<span>Shipper：</span>
											<span>{{showShopName(shopId)}}</span>
										</div>
										<div style="padding:10px;border-bottom:1px #000 solid; height: 30px;">
											<span>Print Date：</span>
											<span>{{item.time}}</span>
										</div>
										<div style="padding:10px;border-bottom:1px #000 solid; height: 30px;">
											Signature of Authorized Seller Personnel
										</div>
										<div style="border-bottom:1px #000 solid; height: 200px;text-align: left;line-height: 300px;">
											Date：
									
										</div>
									</div>
								</div>
							</div>
							<div style="page-break-after:always"></div>
							
						</div>
						
					</div>
				</div>
			
			</div>
		</div>
	</div>
</template>
<script>
import utils from '../utils/utils'
import api from '../api/moudles/processed.js'
	import {
		mapState,
	     mapActions,
	} from 'vuex'

	export default {
	    data() {
	      return {
	        signList:[],
			list:[],
			total:0,
			shopId:null
		  }
	    },
		computed:{
			...mapState({
				picklist: state => state.order.picklist,
				seller: state => state.login.userInfo.userId
			}),
		
			
		},
		created(){
			this.init()
			
		},
	
		methods:{
			...mapActions('order', [
				'getUnprocessOrder',//获取所有商店待处理订单
				'auditOrder',
				'getPrintOrder', //打印订单
				'getOrdersBytrickNo'
				
			]),
			showShopName(id){
				return utils.showshopNameByshopIdOne(id)
			},
			
			init(){

				let parms=JSON.parse(this.$route.query.params)
				api
				.getProcessedOrderBySeller(parms)
				.then(res => {
					if (res.code === 200) {
						console.log(res.data)
						res.data.forEach((p,index) => {
							p.no=index+1
						})
						let arr=res.data
						this.total=arr.length
						this.shopId=arr[0].shopId
						this.list=this.createNew(res.data,res.data.length)
						console.log('list',this.list)
						let list2=[]
						
						for (var index = 0; index < this.list.length;) {
						list2.push(this.list.slice(index,index +=2));
						}
						
						let lastOne=list2[list2.length-1]
						
						let num=lastOne[0].length/2
						let arr1=lastOne[0].slice(0,num)
						let arr2=lastOne[0].slice(num)
						
						list2[list2.length-1]=[arr1,arr2]
						this.signList=list2.map((p,index) => {
							return {
								shopId:111,
								time:utils.setNowTimes(new Date()),
								page:index+1,
								list:p
							}
						})

						console.log('signList',this.signList)
				
				
			
						
					}else{
						this.$message.warning(res.msg)
					}
				})


				
				
				
			},
			
			// 拆分数组
			createNew(arrStr,num){
				console.log(arrStr)
				let arr=JSON.parse(JSON.stringify(arrStr))
				let list=[]
				
				
				for (var index = 0; index < arr.length;) {
				  list.push(arr.slice(index,index +=num));
				}
				
				return list
				
			},

			
		}
	  }
</script>

<style>
	.pick-list-box{
		width: 100%;
		background: #fff;
		z-index: 99999;
		position: absolute;
	}

	/* .pick-list-box .el-table--border{
		border:1px solid #000!important;
	}

	.pick-list-box .el-table td{
		border:1px solid #000!important;
	} */
	
	.pick-list-box .header-desc{
		font-size: 16px;
		font-weight: bold;
		margin-left: 20px;
	}
	.top-header{
		position: relative;
		width: 800px;
		text-align: right;
		margin: 0 auto;
	}
	.pp-wrapper{
		display: flex;

		align-items: center;
	}
	
	.pp-name{
		display:inline-block;
		width: 300px !important;
	}
	
	.ttp-box{
		margin-bottom: 60px;
		border: 1px solid #000;
	}
	
	.pick-list-wrpper{
		width: 100%;
		display: flex;
		justify-content: center;
		font-size: 12px;
	}
	
	.print-area{
		width: 210mm;
		height: 100%;
		box-sizing: border-box;
		padding: 20px;
		margin-bottom: 200px;

	}
	.print-desc{
		display: flex;
		flex: 1;
		
	}
	.print_desc_list{
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: 100%;
		border-bottom: 1px solid #000;
		
	}
	
	.print-content{
		display: flex;
		align-items: center;
		justify-content: space-around;
		width: 100%;
		border-bottom: 1px solid #000;
		font-size: 16px;
		margin-top:10px;
	}
	
	.print_pic{
		
		width: 50px;
		height: 50px;
	}
	img{
		width: 100%;
		height: 100%;
	}
	
	.oopf{
		display: flex;
		flex-direction: column;
	}
	
	.item_name{
		display: inline-block;
		width: 200px;
		padding-left: 20px;
	}

	.itme_pic{
		display: inline-block;
		width: 50px;
		height: 50px;
	}
	.print_desc_item_content{
		display: flex;
		align-items: center;
	}
	.print_desc_item{
		display: inline-block;
		margin-left: 10px;
		width: 100px;
		word-break: break-word;
		text-align: center;
	}

	.dksnfvnb{
		border:1px solid #000
	}


	
	.ttp_index{
		display: inline-block;
		width: 2%;
		text-align: center;
	}
	.ordersn{
		width: 120px;
	}
	.print-content-item{
		display: inline-block;
		
		
	}
	.uui{
		font-size: 16px;
		padding: 2px 0;
	}
	
	.pp-print{
		display: inline-block;
		margin: 10px 10px;
		width: 100px;
		text-align: center;
	}
	
	
	
	
	
	
	
</style>
